import { CATCH_ALL_INSURANCE_OPTIONS } from "@/core/constants";

export const insuranceCompanyFilterOptions = (option, inputValue) => {
  if (CATCH_ALL_INSURANCE_OPTIONS.includes(option.label)) {
    return true;
  }

  const lowerCaseLabel = option.label.toLowerCase();
  const lowerCaseInputValue = inputValue.toLowerCase();

  return !!(lowerCaseLabel === lowerCaseInputValue || lowerCaseLabel.includes(lowerCaseInputValue));
};
